import { FC } from 'react';
import 'twin.macro';
export const AuthTitle: FC<{
  title: string;
}> = ({ title }) => (
  <h2 tw="mb-8 text-3xl leading-9 font-extrabold text-gray-900">{title}</h2>
);
